export default class MobileNavigation {
	private readonly documentClickCallback: EventListener;
	private mobileToggleButton: HTMLButtonElement;

	public constructor() {
		this.documentClickCallback = this.hideMobileNavigation;
		this.mobileToggleButton = document.querySelector('.mobile-navigation-toggle');
		this.mobileToggleButton?.addEventListener('click', this.toggleVisibility);
	}

	private toggleVisibility = (event: MouseEvent): void => {
		event.preventDefault();

		if (this.mobileToggleButton.classList.contains('is-open')) {
			document.body.removeEventListener('click', this.documentClickCallback);
			this.mobileToggleButton.classList.remove('is-open');
		} else {
			document.body.addEventListener('click', this.documentClickCallback);
			this.mobileToggleButton.classList.add('is-open');
		}
	};

	private hideMobileNavigation = (event: MouseEvent): void => {
		const target: Element = event.target as Element;

		if (!target.classList.contains('is-open')) {
			this.mobileToggleButton.classList.remove('is-open');
			document.body.removeEventListener('click', this.documentClickCallback);
		}
	};
}
